import { PassportTemplate as Data } from '@/typings/api/Passport'
import { dateFormatter } from '@/helpers/dateFormatter'
import { DELETE, EDIT, VIEW } from '@/helpers/enums/table-actions'

export const TABLE_ACTIONS = Object.freeze([
  EDIT,
  VIEW,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: false,
    width: '60px',
  },
  {
    text: 'Наименование',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: false,
    width: 144,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата обновления',
    value: 'updated_at',
    sortable: true,
    width: 144,
    field: (value: Data['updated_at']) => (
      (value && dateFormatter(value)) || '-'
    ),
  },
])
